module.exports = __webpack_public_path__ + "static/media/supportplan-icon.31f58142.png";